import { compiledPaths } from '@app/paths';
import { Navigate, useLocation, useParams } from 'react-router-dom';

export const LegacySelectionDetailsPage = () => {
  const { id } = useParams();
  const location = useLocation();

  const { search } = location;

  return <Navigate to={`${compiledPaths.SELECTION_DETAILS({ id: id! })}${search}`} replace />;
};
